import { render } from "./ManutencaoView.vue?vue&type=template&id=71d28712&ts=true"
import script from "./ManutencaoView.vue?vue&type=script&lang=ts"
export * from "./ManutencaoView.vue?vue&type=script&lang=ts"

import "./ManutencaoView.vue?vue&type=style&index=0&id=71d28712&lang=css"

import exportComponent from "/codebuild/output/src1991399693/src/agendamento-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__